import {clearPersistedActionFeedbackSuccess} from "./action-feedback.js";

export const DASHBOARD_EDIT_SAVED_MESSAGE = "dispatch-dashboard:edit-saved";
export const DASHBOARD_RETURN_PATH = "despacho/dashboard";
const DEFAULT_SUCCESS_MESSAGE = "Item salvo com sucesso.";

export const finishDashboardEdit = (redir, navigate, message = DEFAULT_SUCCESS_MESSAGE) => {
    if (redir !== DASHBOARD_RETURN_PATH) return false;

    if (!window.opener || window.opener.closed) {
        navigate(`/${redir}`, false);
        return true;
    }

    clearPersistedActionFeedbackSuccess();
    window.opener.postMessage({type: DASHBOARD_EDIT_SAVED_MESSAGE, message}, window.location.origin);
    window.opener.focus();
    window.close();
    return true;
};